import React from "react";
import Lottie from "react-lottie";
import animationData from "./error404.json";
import i18n from "../../i18nNext/index";
const defaultOptions = {
    loop: false,
    autoplay: true,
    renderer: "svg",
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};

export default class ErrorPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="error-page-container">
                <div className="error-page-text">
                    <h1 className="error-header">404</h1>
                    <div className="font-24">{i18n.t("err.itSeemsThere")}</div>
                    <div className="click-here">
                        <a className="fw-600 font-20" href="/dashboard">
                            {i18n.t("err.clickHere")}
                        </a>{" "}
                        {i18n.t("err.toRejoin")}
                    </div>
                </div>
                <div className="error-page-image">
                    <Lottie options={defaultOptions} />
                </div>
            </div>
        );
    }
}
